import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/torq/Nav";
import Hero from "@/components/torq/Hero";
import Marquee from "@/components/torq/Marquee";
import TheRace from "@/components/torq/TheRace";
import Format from "@/components/torq/Format";
import Divisions from "@/components/torq/Divisions";
import Notify from "@/components/torq/Notify";
import Faq from "@/components/torq/Faq";
import Footer from "@/components/torq/Footer";
import AdminPage from "@/components/torq/AdminPage";
import PaymentResult from "@/components/torq/PaymentResult";
import RegisterPage from "@/components/torq/RegisterPage";
import TicketPage from "@/components/torq/TicketPage";
import LegalPage from "@/components/torq/LegalPage";
import PartnersPage from "@/components/torq/PartnersPage";
import OfficialsPage from "@/components/torq/OfficialsPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div
          data-testid="error-boundary"
          className="min-h-screen bg-[#161614] text-[#f0eee4] flex items-center justify-center font-display font-extrabold text-3xl tracking-wide"
        >
          TORQ Circuit — something snapped. Reload.
        </div>
      );
    }
    return this.props.children;
  }
}

const openRegister = (division) => {
  window.location.assign(`/register?cat=${division || "MENS_OPEN"}`);
};

const Page = () => (
  <main className="bg-[#161614] text-[#f0eee4] font-body antialiased" data-testid="torq-home">
    <div className="grain" aria-hidden="true" />
    <Nav />
    <Hero />
    <Marquee />
    <TheRace />
    <Format />
    <Divisions onReserve={openRegister} />
    <Notify onReserve={openRegister} />
    <Faq />
    <Footer />
    <div className="h-[76px] md:hidden" aria-hidden="true" />
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#161614]/90 backdrop-blur-xl border-t border-[#2e2e2a] px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
      data-testid="sticky-register-bar"
    >
      <a
        href="/register"
        data-testid="sticky-register-btn"
        className="btn-solid flex items-center justify-center w-full min-h-[52px] bg-[#ff5a1f] text-[#0c0c0a] font-mono text-xs tracking-[0.25em] hover:bg-[#ff7340] active:scale-[0.98] transition-transform"
      >
        REGISTER NOW
      </a>
    </div>
  </main>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Page />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/ticket" element={<TicketPage />} />
          <Route path="/payment/result" element={<PaymentResult />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/officials" element={<OfficialsPage />} />
          <Route path="/terms" element={<LegalPage doc="terms" />} />
          <Route path="/refund-policy" element={<LegalPage doc="refund" />} />
          <Route path="/privacy-policy" element={<LegalPage doc="privacy" />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1e1e1c",
            border: "1px solid #2e2e2a",
            color: "#f0eee4",
            borderRadius: 0,
          },
        }}
      />
    </ErrorBoundary>
  );
}
